module.exports = __webpack_public_path__ + "static/media/icnBtnConfirmado.e300aa94.svg";